module.exports = __webpack_public_path__ + "static/media/everyday_bundle_icon.c33e9aef.svg";